import {defineComponent} from "../src";
import DataTable from "../src/component/DataTable";

defineComponent(DataTable.componentName, DataTable, 'example');

